import Cliente from "../Cliente";

export const list = () => {
    return Cliente.setBearerToken()
        .getCliente()
        .get(`${process.env.REACT_APP_API_URL}languages/`);
};
